import api from '@/utils/api';
import {
    FETCH_CUSTOMER_PARTNERS
} from './types';
import { NotificationManager } from 'react-notifications';

export const getListCustomer = (filter) => dispatch => {
    return new Promise((resolve, reject) => {
        return api.get('/partner-customers', { params: filter, skipRedirect: false }).then(res => {
            dispatch({
                type: FETCH_CUSTOMER_PARTNERS,
                payload: res.data.data
            });
            resolve(res.data);
        }).catch(err => {
            console.log(err)
            NotificationManager.error(err.response?.data?.msg);
            reject(err);
        })
    })
}